import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppDispatch } from 'store/store';
import { getNewlyCompleted } from 'store/selectors/gamification.selector';
import { shiftNewlyCompleted } from 'store/reducers/gamification.reducer';
import { useIsGamificationVisibleHere } from 'modules/core/hooks/useIsGamificationVisibleHere';

import { BannerWrapper, BannerIcon, BannerContent, BannerTitle, BannerDescription } from './styles';

const AUTO_DISMISS_MS = 4000;

export const AchievementBanner: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const gamificationVisibleHere = useIsGamificationVisibleHere();
  const newlyCompleted = useSelector(getNewlyCompleted);
  const [isExiting, setIsExiting] = useState(false);
  const isExitingRef = useRef(false);

  const dismiss = useCallback(() => {
    if (isExitingRef.current) return;
    isExitingRef.current = true;
    setIsExiting(true);
    setTimeout(() => {
      dispatch(shiftNewlyCompleted());
      isExitingRef.current = false;
      setIsExiting(false);
    }, 300);
  }, [dispatch]);

  useEffect(() => {
    if (!gamificationVisibleHere) return;

    if (newlyCompleted.length > 0) {
      const timer = setTimeout(dismiss, AUTO_DISMISS_MS);

      return () => clearTimeout(timer);
    }
  }, [newlyCompleted, dismiss, gamificationVisibleHere]);

  if (!gamificationVisibleHere) return null;

  if (newlyCompleted.length === 0) return null;

  const achievement = newlyCompleted[0];

  return (
    <BannerWrapper $isExiting={isExiting} onClick={dismiss}>
      <BannerIcon>🏆</BannerIcon>
      <BannerContent>
        <BannerTitle>{t('gamification.banner.title')}</BannerTitle>
        <BannerDescription>{achievement.name}</BannerDescription>
      </BannerContent>
    </BannerWrapper>
  );
};
